module.exports = __webpack_public_path__ + "static/img/bg-en.0b5b1348.png";